import { getElementFromTrashApi } from '@core/core/api'
import { addDeletedToTrashElementAddErrorNotification } from '@notifications/actions'
import { isDefined } from 'common/helpers'
import type { BaseObject, ProjectElementId, ProjectId } from 'common/types'

import type { TypedDataNode } from './types'

export function getTreeLeafKeys(roots: TypedDataNode[]): string[] {
  return roots.flatMap(node => getLeafKeys(node))
}

function getLeafKeys(node: TypedDataNode): string[] {
  return node.isLeaf || node.children === undefined
    ? [node.key]
    : node.children.flatMap(child => getLeafKeys(child))
}

export async function checkAddEntityDeletedToTrash(
  projectId: ProjectId,
  projectEntityId: ProjectElementId,
  elementType: BaseObject,
) {
  const entity = await getElementFromTrashApi(projectId, projectEntityId, elementType)

  if (isDefined(entity)) {
    addDeletedToTrashElementAddErrorNotification(entity.name)
  }
}
